// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__pMj83","title":"FrontImage_title__26MTO"};